var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.66667 9.33325L13.5532 16.9538C14.4348 17.5709 14.8756 17.8795 15.355 17.999C15.7785 18.1046 16.2215 18.1046 16.645 17.999C17.1244 17.8795 17.5652 17.5709 18.4468 16.9538L29.3333 9.33325M9.06667 26.6666H22.9333C25.1735 26.6666 26.2936 26.6666 27.1493 26.2306C27.9019 25.8471 28.5139 25.2352 28.8974 24.4825C29.3333 23.6269 29.3333 22.5068 29.3333 20.2666V11.7333C29.3333 9.49304 29.3333 8.37294 28.8974 7.51729C28.5139 6.76464 27.9019 6.15272 27.1493 5.76923C26.2936 5.33325 25.1735 5.33325 22.9333 5.33325H9.06667C6.82646 5.33325 5.70635 5.33325 4.8507 5.76923C4.09806 6.15272 3.48613 6.76464 3.10264 7.51729C2.66667 8.37294 2.66667 9.49304 2.66667 11.7333V20.2666C2.66667 22.5068 2.66667 23.6269 3.10264 24.4825C3.48613 25.2352 4.09806 25.8471 4.8507 26.2306C5.70635 26.6666 6.82646 26.6666 9.06667 26.6666Z",
    stroke: "#823DE1",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.aeedaeec432316951f83c106d067f890.svg";
export { ForwardRef as ReactComponent };